import React, {Fragment, useState, useEffect} from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import Script from 'react-load-script'
import axios from 'axios';
import { Cabecera } from '../components/Cabecera';
import { Footer } from '../components/Footer';
import {Listadostandvirualesbajodemanda} from '../components/Listadostandvirualesbajodemanda'
import {Listadopreguntas} from '../components/Listadopreguntas'
import Videojs from '../components/Player';
import {Listadopatrocinadoresinterior} from '../components/Listadopatrocinadoresinterior'
export const EventoBajoDemanda = (props) => {

    let { idEvento,idUsuario } = useParams();
    console.log(useParams())
    let tipoevento = 2
    const history = useHistory();
    const [videoJsOptions, setvideoJsOptions] = useState(false)
    const [dataEventos, setDataEventos] = useState(false)
    

    function groupBy(list, keyGetter) {
        const map = new Map();
        list.forEach((item) => {
             const key = keyGetter(item);
             if(key == 5){
              const collection = map.get(key);
              if (!collection) {
                  map.set(key, [item]);
              } else {
                  collection.push(item);
              }
             }
        });
        return map;
      }

    const logEventoBajoDemanda = async (action,valor) => {
        axios.get(`https://webinars.spinmedia.es/ip.php`)
            .then((dataip) => {
                let dataFormlog = {  
                    "idUsuario": 0,
                    "idEvento": idEvento,
                    "claveUsuario": idUsuario,
                    "nombreUsuario": idUsuario,
                    "ip": dataip.data.ip,
                    "BajoDemanda": true,
                    "Navegador": `${window.navigator.userAgent}`,
                    "accion":action,
                    "accionValor":valor
                }
                let axiosConfig = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },  
                };
               //console.log('LOG::',dataFormlog)
               axios.post(`${process.env.REACT_APP_URL_API}eventos/GrabarEventoLogs_VOD`, dataFormlog, axiosConfig)
               .then((res) => {
                  
                   console.log('Log::',res.data)
                   
                   
               })
               .catch((err) => {
                 console.log('Log ERROR::',err)
               }) 
                
                
            })
            .catch((err) => {
                console.log('Log ERROR IP::',err)
            })
    }//end log

    const playEvent = async (tipo) => {
        
       
            
        logEventoBajoDemanda('Play-bajo-demanda',true)
        
    }
    const pauseEvent = async (tipo) => {
        
           
        logEventoBajoDemanda('Pause-bajo-demanda',true)
       
    }   

    const endedEvent = async (tipo) => {
        
        logEventoBajoDemanda('End-bajo-demanda',true)
       
    } 

    const fetchDataEvento = async () => {
        let urlApi = `${process.env.REACT_APP_URL_API}formatos/obtenerformatopublico`
        
        let dataFormEventos = {  
            "formato": "evento_hijo",
            "idEvento": idEvento
        }
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },  
        };
            
        axios.post(urlApi, dataFormEventos, axiosConfig)
        .then((res) => {
            logEventoBajoDemanda('visualiza-evento-bajo-demanda',idEvento)
            tipoevento = 1 //res.data.data[0].eventos[0].idTipoEvento
            setvideoJsOptions({
                autoplay: false,
                aspectRatio: '16:9',
                controls: true,
                sources: [
                  {
                    src: res.data.data[0].eventos[0].urlPlayer,
                  },
                ],
            }) 
            
            /*let BajoDemanda = false
            if(res.data.data[0].eventos[0].idTipoEvento == 2){BajoDemanda = true} 
            props.logEvento(res.data.data[0].eventos[0].idEvento,BajoDemanda,'visualiza-evento','true')
            */
            
            setDataEventos(res.data.data)
            const grouped = groupBy(res.data.data, item => item.idZona);
            
        })
        .catch((err) => {
            console.log('ERROR',err)
          //  props.isAuth && props.removeAuth()
        }) 
    }

    useEffect(() => {
        fetchDataEvento();
    },[])
   
    if(!dataEventos) { return(<div></div>) }  
     
    return(
        <Fragment>
            <Cabecera imagen={true} urlimagen={dataEventos[1].imagen} texto={dataEventos[1].texto} top={false} removeAuth={props.removeAuth} datosCabecera={dataEventos} />
            <section className="py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                        {
                            /*
                            player tipoeventos
                            1 webinar
                            2 bajo demanda
                            3 presencial
                            4 directo
                            5 contenido
                            6 tutorial
                            */
                        dataEventos[0].eventos[0].idTipoEvento == 5 &&   
                            dataEventos.map(item =>
                                <Fragment>
                                    
                                    {item.idZona === 2 &&  item.tipoZona == 'imagen' &&
                                        <div className="imagenEvento">
                                            <div className="tituloImagen">{item.titulo}</div>
                                            <div className="container-img">
                                                <img src={`${item.imagen}`} alt="img" />
                                            </div>
                                        </div>
                                    }
                                
                                </Fragment>
                            )
                            
                        }
                        {
                        dataEventos[0].eventos[0].idTipoEvento == 2 &&   
                        dataEventos.map(item =>
                            <Fragment>
                                {item.idZona === 2 &&  item.tipoZona == 'imagen' &&
                                    <div className="imagenEvento">
                                        <div className="tituloImagen">{item.titulo}</div>
                                        <div className="container-img">
                                        <Videojs {...videoJsOptions} playEvent={playEvent} pauseEvent={pauseEvent} endedEvent={endedEvent} tipoEvento={dataEventos[0].eventos[0].idTipoEvento} />
                                        </div>
                                    </div>
                                }
                            </Fragment>
                        )

                        }

                        {
                        dataEventos[0].eventos[0].idTipoEvento == 1  &&   
                            dataEventos.map(item =>
                                <Fragment>
                                    {item.idZona === 2 &&  item.tipoZona == 'imagen' &&
                                        <div className="imagenEvento">
                                            <div className="tituloImagen">{item.titulo}</div>
                                            <div className="container-img">
                                            <Videojs {...videoJsOptions} playEvent={playEvent} pauseEvent={pauseEvent} endedEvent={endedEvent} tipoEvento={dataEventos[0].eventos[0].idTipoEvento} />
                                            </div>
                                        </div>
                                    }
                                </Fragment>
                            )
                        }
                        {

                        dataEventos[0].eventos[0].idTipoEvento == 4  &&   
                        dataEventos.map(item =>
                            <Fragment>
                                {item.idZona === 2 &&  item.tipoZona == 'imagen' &&
                                    <div className="imagenEvento">
                                        <div className="tituloImagen">{item.titulo}</div>
                                        <div className="container-img">
                                        <video id="videoEvento" className="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" controls  preload="auto" width="640" height="264" data-setup="{}" 
                                        onPlay={e => playEvent(4)}
                                        onPause={e=> pauseEvent(4)}
                                        onEnded={e=> endedEvent(4)}>
                                            <source src={dataEventos[0].eventos[0].urlPlayer} type="application/x-mpegURL" />
                                        </video>
                                        <Script url='https://vjs.zencdn.net/7.8.4/video.js' />
                                        </div>
                                    </div>
                                }
                            </Fragment>
                        )
                        
                    }

                        {
                            
                            dataEventos.map(item =>
                                <>
                                {
                                dataEventos[0].eventos[0].idTipoEvento == 4 || dataEventos[0].eventos[0].idTipoEvento == 1  ? 
                                <>
                        
                                <Fragment>
                                    <div key={`slider-${Math.floor(Math.random() * 57005)}`}>
                                        <div className="container">
                                            <div className="row">
                                            <div className="col-md-12 sponsor interior">
                                            {
                                                item.idZona === 4 &&   item.tipoZona == 'logotipos_clientes' &&
                                                <div><Listadopatrocinadoresinterior titulo={item.titulo}  items={item.logotipos} /></div>
                                            } 
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                                </>
                                :
                                <Fragment>
                                    <div key={`slider-${Math.floor(Math.random() * 57005)}`}>
                                        <div className="container">
                                            <div className="row">
                                            <div className="col-md-12 sponsor interior">
                                            {
                                                item.idZona === 4 &&   item.tipoZona == 'logotipos_clientes' &&
                                                <div><Listadopatrocinadoresinterior titulo={item.titulo}  items={item.logotipos} /></div>
                                            } 
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                                }
                                </>
                            )
                            
                        }
                        
                        </div>
                        <div className="col-md-4">
                        {
                            dataEventos.map(item =>
                                <Fragment>
                                    {item.idZona === 3 && 
                                        <Fragment>
                                            {item.tipoZona == 'texto' &&
                                                <Fragment> 
                                                <div className="widget">
                                                    <div className="widget-imgbox">
                                                        <div className="titulo">{item.titulo}</div>
                                                        <div dangerouslySetInnerHTML={{__html: item.texto} }/>
                                                    </div>
                                                </div>
                                                </Fragment>
                                        
                                            }  
                                            {item.tipoZona == 'imagen' &&
                                                <div className="widget">
                                                    <div className="widget-imgbox">
                                                        <div className="titulo">{item.titulo}</div>
                                                        <img src={item.imagen} alt="logo"/>
                                                    </div>
                                            
                                                </div>
                                            } 
                                        </Fragment>
                                    }
                                </Fragment>
                            )
                        }
                        <div>
                            <div className="widget">
                                <Fragment>
                                { 
                                    [...groupBy(dataEventos, item => item.idZona)]
                                    .map(([key, value]) => {
                                    
                                        return(<div><Listadostandvirualesbajodemanda keyitems={key} items={value} idEvento={idEvento} idUsuario={idUsuario} logEventoBajoDemanda={logEventoBajoDemanda} /></div>)

                                    })
                                }
                                </Fragment>
                            </div>
                        </div>
                        
                        </div>
                    </div>
                </div> 
            </section>
            <Script url={`https://webinars.spinmedia.es/adnpymes/assets/js/agenda.js`} />
            <Footer />
        </Fragment>
    )

}